import { render } from "./CompanySearchResultView.vue?vue&type=template&id=a78928a0"
import script from "./CompanySearchResultView.vue?vue&type=script&lang=js"
export * from "./CompanySearchResultView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__